import { Component, ViewChild, Injector, Output, EventEmitter, ElementRef, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, NgForm  } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { RegistrationsServiceProxy, UserRegistrationListDto, WorksServiceProxy, } from '@shared/service-proxies/service-proxies';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { PrimengDatatableHelper } from '@shared/helpers/PrimengDatatableHelper';
import { CertificateType } from '@shared/AppEnums';
import { Router } from '@angular/router';

@Component({
    selector: 'certificateModal',
    templateUrl: './certificate-modal.component.html'
})

export class CertificateModalComponent extends AppComponentBase {

    certificateType = CertificateType;

    @ViewChild('certificateModal') modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    primengDatatableHelper: PrimengDatatableHelper = new PrimengDatatableHelper();

    active = false;
    saving = false;

    registration: UserRegistrationListDto = new UserRegistrationListDto();
    isCna = false;

    selectedCertificates = [];

    constructor(
        injector: Injector,
        private _worksService: WorksServiceProxy,
        private _registrationsService: RegistrationsServiceProxy,
        private _fileDownloadService: FileDownloadService,
        private _router: Router,

    ) {
        super(injector);
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');
    }

    close(): void {
        this.active = false;
        this.modalSave.emit(null);
        this.modal.hide();
    }

    onShown(): void {

    }

    public show(registration: UserRegistrationListDto, hasCnaCertificate: boolean, userId: number): void {

        if (!registration.answeredSurvey && registration.surveyId > 0) {
            this._router.navigate(['app/event/answerSurvey/' + registration.surveyId + '/' + registration.id+ '/' + userId]);
        }
        else {
            this.selectedCertificates = [];
            this.registration = registration;

            this.active = true;
            //this.isCna = !!hasCnaCertificate;

            this.primengDatatableHelper.totalRecordsCount = registration.certificates.length
            this.primengDatatableHelper.records = registration.certificates;

            this.modal.show();
        }
    }

    generateCertificate(i: number): void {

        let selected = this.selectedCertificates[i];

        if (selected) {

            if (selected.type == CertificateType.AuthorWork) {

                this._worksService.getCertificate(
                    selected.workId,
                    selected.type
                )
                .subscribe(result => {
                    this._fileDownloadService.downloadTempFile(result);
                    this.generateCertificate(i+1)
                });
            }
            else  {
                this._registrationsService.getCertificate(
                        this.registration.event.name,
                        this.registration.id,
                        this.isCna,
                        selected.activityId ? selected.activityId : undefined,
                        selected.module,
                        selected.topic,
                        selected.role,
                        selected.type,
                        undefined,
                        false,
                        0,
                    )
                    .subscribe(result => {
                        this._fileDownloadService.downloadTempFile(result);
                        this.generateCertificate(i+1)
                    }
                );
            }
        }
        else
            this.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/event/my-registrations/modal/certificate-modal.component.ts